import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const NotificationBell = ({ unreadCount, onClick, className = '' }) => {
  const { isDark } = useTheme();

  return (
    <button
      onClick={onClick}
      className={`relative p-2 rounded-lg hover:bg-opacity-50 transition-colors duration-200 ${className} ${
        isDark 
          ? 'hover:bg-gray-700' 
          : 'hover:bg-gray-100'
      }`}
      aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`}
      title={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ''}`}
    >
      {/* Bell Icon */}
      <svg 
        className={`h-6 w-6 transition-colors duration-200 ${
          isDark ? 'text-gray-300' : 'text-gray-600'
        }`}
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" 
        />
      </svg>
      
      {/* Badge */}
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 h-5 w-5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center min-w-[20px] animate-pulse">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
};

export default NotificationBell;
